<template>
  <XAppShell
    :use-svg-background="false"
    :header-menu-items="headerMenuItems"
    :is-authenticated="isShellAuthenticated"
    :is-ready="isReady"
    :show-bottom-nav="BOTTOM_NAV_ENABLED"
    :show-side-nav="SIDE_NAV_ENABLED"
    :side-nav-options="SIDE_NAV_OPTIONS"
    @menu-action="onHeaderMenuAction"
    @ui-error="notify($event, 'error')"
  />
</template>

<script setup>
  import { useMeStore } from '@xstudios/xapp-auth/stores/meStore'
  import { useRuntimeAuthStore } from '@xstudios/xapp-auth/stores/runtimeAuthStore'
  import { useNotificationState } from '@xstudios/xapp-core/foundation'
  import { XAppShell } from '@xstudios/xapp-core/shell'
  import { useRouter } from 'vue-router'

  import { AUTH_DISABLED } from '@/config/featureFlags'
  import {
    BOTTOM_NAV_ENABLED,
    SIDE_NAV_ENABLED,
    SIDE_NAV_OPTIONS,
  } from '@/config/navigation'
  import {
    buildHeaderMenuItems,
    handleHeaderMenuAction,
  } from '@/domains/integrations/actions/headerMenuActions'
  import { useJobNotificationsStore } from '@/domains/jobs/stores/jobNotificationsStore'

  const router = useRouter()
  const authStore = useRuntimeAuthStore()
  const meStore = useMeStore()
  const jobNotificationsStore = useJobNotificationsStore()
  const isReady = ref(false)
  const { notify } = useNotificationState()
  const isShellAuthenticated = computed(
    () => AUTH_DISABLED || authStore.authenticated
  )
  const headerMenuItems = computed(() => buildHeaderMenuItems())

  async function onHeaderMenuAction(action) {
    await handleHeaderMenuAction(action, {
      authStore,
      meStore,
      router,
    })
  }

  router.isReady().then(() => {
    // Prevent flash of content
    jobNotificationsStore.resumePolling()
    isReady.value = true
  })
</script>
